import { Link } from 'react-router-dom';
import type { JourneeDuJour } from '../partage/api/types';
import { heureLisible } from '../partage/datesEnMots';
import { MA_JOURNEE, RIEN_DE_PREVU_AUJOURDHUI } from '../partage/vocabulaire';
import './PapiersDeMaintenant.css';

/**
 * « Ma journée », sur une feuille à lignes scotchée sous « À vérifier » (chantier
 * maintenant-en-etages, modification 01 ; maquette du carnet `maintenant.html`, `.pi.lignes.journee-m`) :
 * ses tâches à leur heure, dans l'ordre des heures. Le clic ouvre l'Agenda sur aujourd'hui, comme
 * le lien « Ma journée » de la tête de page : planifier sa journée se fait là.
 */
export function JourneeEnPostIt({ journee, aujourdhui }: { journee: JourneeDuJour['journee']; aujourdhui: string }) {
  const taches = [...(journee?.taches ?? [])].sort((a, b) => a.heure.localeCompare(b.heure));
  return (
    <Link className="papier-de-maintenant journee-en-post-it" to={`/agenda?jour=${aujourdhui}`}>
      <span className="papier-de-maintenant-scotch" aria-hidden="true" />
      <span className="papier-de-maintenant-titre">{MA_JOURNEE}</span>
      {taches.length === 0 ? (
        <span className="papier-de-maintenant-main">{RIEN_DE_PREVU_AUJOURDHUI}</span>
      ) : (
        taches.map((t) => (
          <span key={t.bulleId} className={`journee-en-post-it-heure${t.etat === 'fait' ? ' est-faite' : ''}`}>
            <b>{heureLisible(t.heure.slice(0, 5))}</b>
            <span>{t.titre}</span>
          </span>
        ))
      )}
    </Link>
  );
}
